import React, { useState } from 'react';
import api from '../chat/api';
import { toast } from "../../utils/appToast";

const DeleteChatModal = ({ isOpen, onClose, chatId, onDeleted }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  if (!isOpen) return null;

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await api.post(`/api/v1/copilot/delete-session/`, {
        chat_id: chatId
      });
      setIsSuccess(true);
      setTimeout(() => {
        setIsSuccess(false);
        setIsDeleting(false);
        onDeleted(chatId);
        onClose();
      }, 1000); // Wait 1s to show "Deleted" state before closing
    } catch (error) {
      console.error("Failed to delete chat:", error);
      toast.error("Failed to delete chat. Please try again.");
      setIsDeleting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/30 z-[110] flex items-center justify-center p-4">
      <div className="bg-white rounded-xl w-full max-w-[480px] p-6 shadow-2xl font-outfit text-center">
        
        <h2 className="text-[18px] font-semibold text-[#18181B] mb-3">Delete Chat?</h2>
        <p className="text-[15px] text-[#71717A] mb-6 leading-relaxed px-4">
          This action will permanently delete the selected chat from your history and cannot be undone.
        </p>

        <div className="flex gap-4 justify-center">
          <button 
            onClick={onClose}
            disabled={isDeleting || isSuccess}
            className="flex-1 max-w-[140px] px-4 py-2.5 rounded-lg border border-[#C95EBE] text-[#C95EBE] font-semibold hover:bg-pink-50 transition-colors disabled:opacity-50"
          >
            Cancel
          </button>
          <button 
            onClick={handleDelete}
            disabled={isDeleting || isSuccess}
            className="flex-1 max-w-[140px] px-4 py-2.5 rounded-lg border border-gray-200 text-[#52525B] font-semibold hover:bg-[#E21919BF] hover:text-white transition-colors disabled:opacity-50 flex items-center justify-center"
          >
            {isSuccess ? (
              <span className="text-red-500 font-bold">Deleted</span>
            ) : isDeleting ? (
              <span className="flex items-center gap-2 text-red-500">
                <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Deleting
              </span>
            ) : (
              "Delete"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteChatModal;
